import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeReceivablesTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.receivables-trend",
  name: "Receivables movement",
  description: "Receivables movement across the selected period.",
  apps: [
    "home",
    "finance",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "balance",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "account_type",
        operator: "eq",
        value: "asset_receivable",
      },
    },
    graphQueries: [
      {
        name: "Customer receivables",
        query: {
          version: 1,
          source: "finance.journal-items",
          ...period(30),
          select: [
            {
              type: "field",
              field: "accounting_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "balance",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "accounting_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
          where: {
            type: "condition",
            field: "account_type",
            operator: "eq",
            value: "asset_receivable",
          },
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Receivables movement",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$0",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
